import { defaultShouldDehydrateQuery, QueryClient } from '@tanstack/react-query'

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
        retry: false,
      },
      dehydrate: {
        shouldDehydrateQuery: (query) => {
          // Errored queries crash hydration when TanStack spreads query.meta —
          // skip them, including pending queries that already carry an error.
          if (query.state.status === 'error') {
            return false
          }

          if (query.state.status === 'pending') {
            return !query.state.error
          }

          return defaultShouldDehydrateQuery(query)
        },
      },
    },
  })
}
